/* eslint new-cap: 0 */

import React from 'react';
import { Route } from 'react-router';

/* containers */
import { App } from './containers/App';
import { HomeContainer } from './containers/HomeContainer';
import LoginView from './components/LoginView';
import UsersListView from './components/Admin/UsersListView';
import UserView from './components/Admin/UserView';
import CustomerView from './components/Customer/CustomerView';
import NotFound from './components/NotFound';

import { DetermineAuth } from './components/DetermineAuth';
import { requireAuthentication } from './components/AuthenticatedComponent';
import { requireNoAuthentication } from './components/notAuthenticatedComponent';

export default (
    <Route path="/" component={App}>
        <Route path="home" component={requireNoAuthentication(HomeContainer)} />
        <Route path="login" component={requireNoAuthentication(LoginView)} />
        <Route path="admin/user" component={requireAuthentication(UserView)} />
        <Route path="admin/main" component={requireAuthentication(UsersListView)} />
        <Route path="secure" component={requireAuthentication(CustomerView)} />
        <Route path="*" component={DetermineAuth(NotFound)} />
    </Route>
);



// WEBPACK FOOTER //
// ./src/routes.js